import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'

import useOeBlock from '@aytm/app/stats/page/question-views/oe/states/useOeBlock'
import { MN_FAMILY_LIB } from '@aytm/app/stats/page/question-views/mn/components/comments-section/lib/family'
import { MN_PROPS_BUILDERS } from '@aytm/app/stats/page/question-views/mn/components/comments-section/lib/props'
import useCommentsCollapsed from '@aytm/app/stats/page/question-views/mn/components/comments-section/states/useCommentsCollapsed'

import Controls from '@aytm/app/stats/page/question-views/mn/components/comments-section/CommentsControls'

import VerbatimView from '@aytm/app/stats/page/question-views/oe/components/views/VerbatimView'
import WordCloudView from '@aytm/app/stats/page/question-views/oe/components/views/WordCloudView'

import ChartPlaceholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'

import { BLOCK_PROP_TYPES } from '@aytm/app/stats/page/question-views/oe/Block'

// The menu-test comments block. The narrowest member of the open-ended family: quotes and word
// cloud only -- no sentiments, no codebooks, so no chart and no items list at all -- behind a
// collapse strip that no other type has.
export const CommentsBlockView = ({
  viewMode,
  components,
  controlsProps,
  verbatimProps,
  collapsed = false,
  missingTotals = false,
  wcProps
}) => {
  // totals are still being computed page-wide: no controls, just a held-open frame
  if (missingTotals) return <ChartPlaceholder isLoading />

  return (
    <>
      {isComponentOn(components, 'viewModes') && <Controls {...controlsProps} />}
      {!collapsed && (
        <>
          {'verbatim' === viewMode && <VerbatimView components={components} {...verbatimProps} />}
          {'wordcloud' === viewMode && <WordCloudView {...wcProps} />}
        </>
      )}
    </>
  )
}

const CommentsBlock = props => {
  const { handlers, onCollapsedChange } = props

  // the collapse rides in the same param bag as the rest, so it is split off before the block
  // state - which knows nothing about it - sees the bag
  const { mncc, ...params } = props.params || {}

  const { collapsed, onToggle } = useCommentsCollapsed({ param: mncc, onCollapsedChange })

  const extra = useMemo(() => ({ collapsed }), [collapsed])

  const allHandlers = useMemo(() => ({ ...handlers, onToggle }), [handlers, onToggle])

  const blockProps = useOeBlock(
    { ...props, params, handlers: allHandlers, lib: MN_FAMILY_LIB, extra },
    MN_PROPS_BUILDERS
  )

  return <CommentsBlockView {...blockProps} collapsed={collapsed} />
}

CommentsBlock.displayName = 'MnCommentsBlock'
CommentsBlockView.displayName = 'MnCommentsBlockView'

CommentsBlockView.propTypes = {
  viewMode: PropTypes.string.isRequired,
  components: PropTypes.object,
  missingTotals: PropTypes.bool,
  collapsed: PropTypes.bool,
  controlsProps: PropTypes.object,
  verbatimProps: PropTypes.object,
  wcProps: PropTypes.object
}

CommentsBlock.propTypes = { ...BLOCK_PROP_TYPES, onCollapsedChange: PropTypes.func }

export default CommentsBlock
